module.exports = __webpack_public_path__ + "img/tri_wizards_cup.7fe1f0fe.jpg";